export default __webpack_public_path__ + "static/media/logo.144bed39.svg";